
import { LoadPanel } from 'devextreme-react/load-panel';

type LoadVisible = {
    visible: boolean;
}

const LoadPanelFullScreen: React.FC<LoadVisible> = ({ visible }) => {
    
    return (
        <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={"center"}
            visible={visible}
            showIndicator={true}
            shading={true}
            showPane={true}
        />
    )
}

export { LoadPanelFullScreen }